import React from 'react';
import { FaArrowRightLong } from 'react-icons/fa6';
import './ChangedValueItem.scss';

interface IChangedValueItemProps {
    oldValue: string | number;
    newValue: string | number;
    change?: number;
}

export const ChangedValueItem: React.FC<IChangedValueItemProps> = ({ oldValue, newValue, change = null }) => {
    return (
        <div className='changed-value'>
            <span className='changed-value__old-value'>{oldValue}</span>
            <FaArrowRightLong color='#0066A6' />
            <span className='changed-value__new-value'>{newValue}</span>
            {change && <span className='changed-value__change'>({change! < 0 ? change : '+' + change})</span>}
        </div>
    );
};
